// extracted by mini-css-extract-plugin
export var container = "_ic-0";
export var dotAnimation = "_ic-2";
export var dotsLoading = "_ic-1";